import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule  } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { MenuModule } from 'primeng/menu';
import { NgxMaskModule } from 'ngx-mask';
import { SlideshowModule } from 'ng-simple-slideshow';
import { SliderComponent } from './shared/slider/slider.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MessageComponent } from './shared/message/message.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgxGalleryModule } from 'ngx-gallery';

@NgModule({
  declarations: [
    AppComponent,
    SliderComponent,
    MessageComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SlideshowModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    MenuModule,
    HttpClientModule,
    NgxGalleryModule,
    NgxLoadingModule.forRoot({}),
    NgxSmartModalModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
